import type { EntityRegisterResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetEntitiesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetEntitiesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook, REFERENCE_DATA_STALE_TIME_MS } from 'src/utils';

type UseGetEntitiesArgs = Record<string, never>;

export const useGetEntities = createQueryHook<
  UseGetEntitiesArgs,
  EntityRegisterResponseRow[],
  GetEntitiesQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.entity.register.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ entity: data ?? [] }),
  // Org reference data; writes invalidate it. See COI-882.
  trpcStaleTime: REFERENCE_DATA_STALE_TIME_MS,
  graphqlDocument: GetEntitiesDocument,
});
